// CSS
import mainStyle from "./mainStyle.module.scss";

// Packages
import React, { useState, Suspense, lazy, useEffect } from "react";
import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

// Icons
import { ReactComponent as BotProIcon } from "assets/images/icons/icn_chatbot_pro.svg";
import { ReactComponent as BotProHoverIcon } from "assets/images/icons/icn_chatbot_pro_hover.svg";
import { ReactComponent as BotNotProIcon } from "assets/images/icons/icn_chatbot_gray_pro.svg";
import { ReactComponent as BotPreviewIcon } from "assets/images/icons/icn_chatbot_preview.svg";
import { ReactComponent as BotPreviewHoverIcon } from "assets/images/icons/icn_chatbot_preview_hover.svg";

// Const
import { EXCLUDE_PATHS } from "./const";

// Hooks
import { useLocalAuthScope } from "./hook";
import useZustandStore from "zustandStore";

// Components
import LinkModal from "components/LinkModal";
const ChatBotPanel = lazy(() => import("./components/ChatBotPanel"));

const AIChatBot = ({ scopeReady, wsData }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isLinkModalOpen, setIsLinkModalOpen] = useState(false);
  const { auth, isAuthReady } = useLocalAuthScope(scopeReady);
  const isPreviewMode = true;
  const isUnityProSubscribed = useZustandStore((state) => state.isUnityProSubscribed);

  const shouldHide = EXCLUDE_PATHS.some((path) => location.pathname.includes(path));
  const isSiteLevel = isAuthReady && auth.scopeLevel === "site";

  useEffect(() => {
    if (!auth?.sites?.id) return;
    setIsOpen(false);
  }, [auth?.sites?.id]);

  if (shouldHide || !isSiteLevel) {
    return null;
  }

  const onPreviewBotClick = () => {
    if (isPreviewMode) {
      setIsOpen(true);
    }
  };

  const onBotClick = () => {
    if (!isUnityProSubscribed) {
      setIsLinkModalOpen(true);
      return;
    }
    setIsOpen(true);
  };

  return (
    <Box className={mainStyle["chatbot-wrapper"]}>
      {
        !isOpen &&

        <>
          {/* PREVIEW Mode */}
          {
            isPreviewMode &&
            <Box
              className={mainStyle["floating-btn"]}
              onClick={onPreviewBotClick}
            >
              <>
                <BotPreviewIcon className={mainStyle["default-icon"]} />
                <BotPreviewHoverIcon className={mainStyle["hover-icon"]} />
              </>
            </Box>
          }

          {/* PRO License */}
          {
            !isPreviewMode &&
            <Box
              className={mainStyle["floating-btn"]}
              onClick={onBotClick}
            >
              {
                isUnityProSubscribed ? (
                  <>
                    <BotProIcon className={mainStyle["default-icon"]} />
                    <BotProHoverIcon className={mainStyle["hover-icon"]} />
                  </>
                ) : (
                  <BotNotProIcon className={mainStyle["not-pro-icon"]} />
                )
              }
            </Box>
          }
        </>
      }

      {isOpen && (
        <Suspense fallback={null}>
          <ChatBotPanel
            scopeReady={scopeReady}
            wsData={wsData}
            setIsOpen={setIsOpen}
          />
        </Suspense>
      )}

      <LinkModal
        open={isLinkModalOpen}
        content="AI Chatbot is a Nuclias Unity Pro feature. Please subscribe to Nuclias Unity Pro to use this service."
        transparentBackdrop
        onClose={() => setIsLinkModalOpen(false)}
        onLinkClick={() => {
          setIsLinkModalOpen(false);
          const isMspScope = auth?.realm?.hasManageOrg === true && !auth?.orgs?.id;
          navigate(isMspScope ? "/msp/license" : "/license");
        }}
      />
    </Box>
  );
};

export default AIChatBot;

